import { type FunctionComponent, } from "react";

export const ChartBars2: FunctionComponent<{}> = () => (
	<div className="icon chartbars2">
		<svg viewBox="0 0 39 35" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.92224 26.0303L7.92224 22.925" stroke="#D3D3D3" strokeWidth="3" strokeLinecap="round" />
			<path d="M13.9222 26.0303L13.9222 18.2994" stroke="#D3D3D3" strokeWidth="3" strokeLinecap="round" />
			<path d="M19.9222 26.0303L19.9222 17.5944" stroke="#D3D3D3" strokeWidth="3" strokeLinecap="round" />
			<path d="M25.9222 26.0303L25.9222 13.8053" stroke="#D3D3D3" strokeWidth="3" strokeLinecap="round" />
			<path d="M31.9222 26.0303L31.9222 8.52527" stroke="#D3D3D3" strokeWidth="3" strokeLinecap="round" />
			<rect x="2.42322" y="2.95605" width="34.998" height="28.1484" rx="4.5" stroke="#D3D3D3" strokeWidth="3" />
		</svg>
	</div>
);
